// @core/api/endpoints/analytics/delete_widget.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/analytics';

/**
 * Delete widget
 * Removes a widget from its dashboard.
 */
export async function DeleteWidget(
  widget_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/widgets/:widget_id`;
  requestPath = requestPath.replace(':widget_id', encodeURIComponent(widget_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
